import axios from 'axios';

// import {
//     API_BASE_URL
// } from '../constants/index';
import { API_BASE_URL } from '../constants';

export default class RiskAssessmentService {
	static instance;

	static getInstance() {
		if (!RiskAssessmentService.instance) {
			RiskAssessmentService.instance = new RiskAssessmentService();
		}

		return RiskAssessmentService.instance;
	}

    async fetchRisks(assetId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/software/${assetId}/risks`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data.data
    }

    async fetchMatrix(assetId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/risk_rate/matrix`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data.data
    }

    async fetchSoftwareMatrix(assetId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/software/${assetId}/risk_rate/matrix`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data.data
    }

    async fetchOwners(assetId, payload = {}){
        const response = await axios.post(`${API_BASE_URL}/analystAndAdminAnalyst.list`, payload, {
            params: {},
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
  
        return response.data.data;
    }

    async fetchManagers(assetId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/manager.list`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });

        return response.data.data
    }

    async fetchCategories(assetId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/risk_rate_category/index`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });

        return response.data.data
    }

    async fetchLocations(assetId, payload = {}){
        const response = await axios.post(`${API_BASE_URL}/report.country.list`, payload, {
            params: {},
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
  
        return response.data.data;
    }

    async deleteRisk(assetId, riskId){
        const response = await axios.delete(`${API_BASE_URL}/risk_rate/${riskId}/delete`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                }
            }
        );
  
        return response.data.data;
    }    

    async updateRiskTitle(riskId, payload = {}) {
        const response = await axios.post(
            `${API_BASE_URL}/risk_rate/${riskId}/update_title`,
            payload,
            {
                params: {},
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data.data
    }

    async acceptRisk(riskId, payload = {}) {
        const response = await axios.post(
            `${API_BASE_URL}/risk/${riskId}/accept`,
            payload,
            {
                params: {},
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data.data
    }

    async addLegalEntity(riskId, legalEntityId) {
        const response = await axios.post(
            `${API_BASE_URL}/risk_rate/${riskId}/add_legal_entity`,
            {
                legalEntity: legalEntityId,
            },
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`,
                },
            }
        );
    
        return response.data.data;
    }
    
    async removeLegalEntity(riskId, legalEntityId) {
        const response = await axios.post(
            `${API_BASE_URL}/risk_rate/${riskId}/remove_legal_entity`,
            {
                legalEntity: legalEntityId,
            },
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`,
                },
            }
        );
    
        return response.data.data;
    }
}